module.exports = __webpack_public_path__ + "img/title.e689aaa5.svg";